import * as React from "react";
import Modal from "@mui/material/Modal";
import {
  StyledBox,
  StyledBoxCard,
} from "./style";
import { Box, Button } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { Form, Formik } from "formik";
import theme from "../../../theme";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { StyledBoxFlex } from "../success-virtual-locker/style";
import { StyledTypography } from "../manual-split-calculation/style";
import CrossIcon from "../../../assets/Icons/CrossIcon";
import CustomInput from "../../common/input/CustomInput";
import CustomDropdown from "../../common/common-dropdown/CustomDropdown";
import { StatusOptionDropdown } from "../product-details/constant";
import { SHIPPING_PARTNER_ADD, SHIPPING_PARTNER_EDIT, SHIPPING_PARTNER_LIST } from "../../../actions/admin/customer-actions";

// Yup Validation Schema
const validationSchema = Yup.object({

  name: Yup.string()
    .trim()
    .required("Name is required")
    .min(2, "Name must be at least 2 characters")
    .max(50, "Name must be at most 50 characters"),

  is_active: Yup.boolean()
    .required("Status is required")
    .oneOf([true, false], "Invalid status"),

  type: Yup.string()
    .required("Type is required"),

  region: Yup.string()
    .required("Region is required"),
});

export default function ShippingPartners({ open, handleClose, isEditMode, editRecord }) {
  const dispatch = useDispatch();
  const [initialValue, setInitialValue] = React.useState({
    name: "",
    region: "",
    type: "",
    is_active: "",
  })
  
  const getRecordList = React.useCallback(
    (values) => {
      dispatch({
        type: SHIPPING_PARTNER_LIST,
        payload: values,
      });
    },
    [dispatch]
  );

  React.useEffect(()=>{
    if(isEditMode){
      setInitialValue({
        name: editRecord?.name || "",
        region: editRecord?.region || "",
        type: editRecord?.type || "",
        is_active: editRecord?.is_active || "",
      })
    }
  }, [isEditMode, editRecord])
  return (
    <Modal open={open} onClose={handleClose}>
      <StyledBox>
        <StyledBoxCard>
          <StyledBoxFlex>
            <StyledTypography>Create Shipping Partner</StyledTypography>
          </StyledBoxFlex>
          <CrossIcon color={theme.palette.custom.white} onClick={handleClose} />
        </StyledBoxCard>

        <Formik
          initialValues={initialValue}
          validationSchema={validationSchema}
          enableReinitialize={true}
          onSubmit={(values) => {
            if(isEditMode && editRecord.id){
              dispatch({
                type: SHIPPING_PARTNER_EDIT,
                payload: {
                  ...values,
                  id: editRecord.id,
                  onSuccess: () => {
                    getRecordList({});
                    handleClose();
                  },
                },
              });
            } else {
              dispatch({
                type: SHIPPING_PARTNER_ADD,
                payload: {
                  ...values,
                  onSuccess: () => {
                    getRecordList({});
                    handleClose();
                  },
                },
              });
            }
          }}
        >
          {({ values, errors, touched, setFieldValue, handleChange, handleBlur }) => (
            <Form>
              <Box sx={{ p: 2 }}>
                <Grid container spacing={2}>
                  {/* Name */}
                  <Grid size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
                    <CustomInput
                      color={
                        theme.palette.custom.productTextColor
                      }
                      fontSize={theme.typography.regular.fontSize}
                      height="10px"
                      required
                      placeholder="Name"
                      customLabel="Name"
                      name={`name`}
                      value={values.name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        touched.name &&
                        Boolean(errors.name)
                      }
                      helperText={
                        touched.name &&
                        errors.name
                      }
                    />
                  </Grid>

                  {/* Status */}
                  <Grid size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
                    <CustomDropdown
                      options={StatusOptionDropdown}
                      color={
                        theme.palette.custom.productTextColor
                      }
                      fontSize={theme.typography.regular.fontSize}
                      height="44px"
                      required
                      customLabel="Status"
                      name={`is_active`}
                      value={values.is_active}
                      onBlur={handleBlur}
                      setFieldValue={setFieldValue}
                      error={
                        touched.is_active &&
                        Boolean(errors.is_active)
                      }
                      helperText={
                        touched.is_active &&
                        errors.is_active
                      }
                    />
                  </Grid>

                  {/* Region */}
                  <Grid size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
                    <CustomInput
                      color={
                        theme.palette.custom.productTextColor
                      }
                      fontSize={theme.typography.regular.fontSize}
                      height="10px"
                      required
                      placeholder="Region"
                      customLabel="Region"
                      name={`region`}
                      value={values.region}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        touched.region &&
                        Boolean(errors.region)
                      }
                      helperText={
                        touched.region &&
                        errors.region
                      }
                    />
                  </Grid>

                  {/* Type */}
                  <Grid size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
                    <CustomInput
                      color={
                        theme.palette.custom.productTextColor
                      }
                      fontSize={theme.typography.regular.fontSize}
                      height="10px"
                      required
                      placeholder="Type"
                      customLabel="Type"
                      name={`type`}
                      value={values.type}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        touched.type &&
                        Boolean(errors.type)
                      }
                      helperText={
                        touched.type &&
                        errors.type
                      }
                    />
                  </Grid>

                  {/* Submit */}
                   <Grid container justifyContent="space-between" width="100%">
                    <Grid item>
                      <Button variant="outlined" onClick={handleClose}>
                        Cancel
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button variant="contained" color="primary" type="submit">
                        Save
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            </Form>
          )}
        </Formik>
      </StyledBox>
    </Modal>
  );
}
